import BaseHotspot from "./BaseHotspot";

/**
 * Type of hotspot where the action is to transition to another image
 */
export default class PinnedVideoNode extends BaseHotspot {
  /**
   * Initialises a pinned video node
   *
   * @param config
   *
   * @example
   * {
   *   u: 0,
   *   v: 0.5,
   * }
   */
  constructor(player, config) {
    super(player, config);

    this.loadTexture({
      url: `${window.location.origin}/tour/assets/hotspots/pinnedNode.png`,
    });

    this._config = config;
  }
}
